// extracted by mini-css-extract-plugin
export var numpadContainer = "_go-1";
export var phoneButton = "_go-0";